import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import {VwuiModalRef} from '@bvgo-ict/vwui-angular';

@Component({
    selector: 'app-publish-quick-scan-version-modal',
    templateUrl: './publish-quick-scan-version-modal.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PublishQuickScanVersionModalComponent {
    modalRef = inject(VwuiModalRef);


    public loading = false;

    async submit() {
        this.modalRef.close(true);
    }

}
